import { render, staticRenderFns } from "./ContentsCard.vue?vue&type=template&id=3e4611ca&"
import script from "./ContentsCard.vue?vue&type=script&lang=js&"
export * from "./ContentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports